var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcpac(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 222.857,
    height: 314.132,
    viewBox: "0 0 222.857 314.132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    cx: 63.792,
    cy: 63.792,
    r: 63.792,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2513",
    "data-name": "Path 2513",
    d: "M148.5,126.624a.876.876,0,0,0,.639-.962,1.617,1.617,0,0,1,.964-.964h.32c1.019-1.119,2.762-1.515,3.208-3.208-.084-.941.726-.985.645-1.926h.32c1.069-.747,3.09-4.835,1.863-5.868a.45.45,0,0,0-.22-.183.747.747,0,0,0-.147-.039l-.016,0a1.23,1.23,0,0,0-.2,0c-.372-.052-.569.071-.642.32a9.678,9.678,0,0,0-4.169.962h-.322a1.408,1.408,0,0,0-1.281-.639c-.446-1.478-.757-3.092-2.246-3.53a2.9,2.9,0,0,0-1.284-1.284c-1.08.118-.535-1.389-.962-1.924-2.993-3.64-4.19-9.073-7.06-12.833.742,0,1.717,2.482,1.926.962v-.322c.854-.668-.8-1.533-.642-2.566a25.337,25.337,0,0,1-10.438-1.25h0c-.073-.037-.149-.071-.228-.1l-.039-.016c-.068-.029-.136-.052-.207-.079l-.063-.021c-.068-.021-.139-.039-.212-.06l-.066-.018c-.1-.018-.194-.037-.3-.052-.322-.1-.642-.212-.962-.325-.9,1.19-.01,2.285-1.6,2.888-2.487-1.468-5.4-2.511-7.7-4.169a4.218,4.218,0,0,0-.32-3.21h-1.6c-3.373,1.067-7.935-.018-10.268,2.568-.97-.314-1.91-.658-2.888-.964a3.489,3.489,0,0,1-.469.692c-.076.063-.149.131-.22.2-.055.05-.107.1-.16.149q-.149.145-.291.3c-1.368,1.119-3.137,1.832-3.045,4.408h0c-.165.252-.333.5-.511.742h0c-3.47,2.626-7.883,6.814-5.889,11.8.008.755-.553.943-.322,1.926-.406.556-1.082.839-.962,1.924-.092.519.3.553.32.962.267.909-.451.831-.32,1.606a13.667,13.667,0,0,1,2.568,2.243c-.152,1.009.862.849.962,1.606.595,2.078,2.2,3.15,3.85,4.172h.962v.32c-.052.527,1.979.527,1.926,0v-.32h.962c.508-.029,1.224.152,1.284-.322h.32c.273.3,1.656,1.077,1.926.322v-.322c.98.233.943-.553,1.926-.322a6.276,6.276,0,0,0,2.243-.962h1.287c.27.692,1.4.519,1.924.962v.964c1.318.5,3.373.265,3.85,1.6V124.7c-.312.008-.249.393-.32.642-.645.359-.369,2.482,0,2.888,2.146,1.811,3.223,4.688,3.85,8.022-.233.98.553.943.322,1.924a4.857,4.857,0,0,0-1.287,2.888,3.248,3.248,0,0,0-.639,2.568c.176.464-.375,1.659.32,1.6-.052.372.071.569.32.642.314.008.252.39.322.639a.888.888,0,0,0,.642.964,3.77,3.77,0,0,1,.962,2.566c.307,2.8.325,5.878,2.246,7.06-.052.372.071.569.32.639-.2,1.376,1.048,1.31.964,2.568v1.6c1.161,1.418,3.611.6,5.553.362h0a3.4,3.4,0,0,0,.545-.047,4.3,4.3,0,0,1,.639.008c.613-.136,1.381-.118,1.281-.964.577.042.679-.391,1.287-.32a4.542,4.542,0,0,0,1.6-1.6v-.322c.642-.532,1.491-.86,1.6-1.924.608-.037.225-1.061.964-.962a1.235,1.235,0,0,0,.584-1.1c.018-.438-.06-.912-.018-1.347.993-2.222,4.631-1.677,4.811-4.224h-.181c.181-.362.545-.726-.278-1.378a2.271,2.271,0,0,1-.3-.5,3.445,3.445,0,0,1-.259-1.132c-.618-2.623,2.655-2.442,3.653-4.515a4.393,4.393,0,0,0,.5-1.261,7.862,7.862,0,0,0,.144-2.83,2.678,2.678,0,0,0-.01-.548,1.319,1.319,0,0,0-.629-1.056h-.32c.131-.776-.587-.7-.322-1.6-.173-.466.375-1.661-.32-1.606v-.962a10,10,0,0,1,2.566-4.172v-.32C147.574,126.978,148.6,127.363,148.5,126.624Z",
    transform: "translate(-90.41 -86.195)",
    fill: "#fff",
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_919",
    "data-name": "Group 919",
    transform: "translate(-62.756 -52.294)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_904",
    "data-name": "Group 904",
    transform: "translate(69.546 299.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2379",
    "data-name": "Path 2379",
    d: "M91.63,165.247V146.541H95.6v18.706Z",
    transform: "translate(-22.752 -146.271)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2380",
    "data-name": "Path 2380",
    d: "M103.494,149.74a4.046,4.046,0,0,0-3.467,1.68,7.834,7.834,0,0,0-1.229,4.691q0,6.258,4.7,6.258a14.8,14.8,0,0,0,4.772-.985v3.328a13.256,13.256,0,0,1-5.142.959,7.847,7.847,0,0,1-6.245-2.476q-2.162-2.473-2.162-7.107a11.609,11.609,0,0,1,1.061-5.113,7.688,7.688,0,0,1,3.053-3.368,9.043,9.043,0,0,1,4.662-1.169,12.6,12.6,0,0,1,5.477,1.318l-1.279,3.223a21.353,21.353,0,0,0-2.112-.87A6.3,6.3,0,0,0,103.494,149.74Z",
    transform: "translate(-17.749 -146.438)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2381",
    "data-name": "Path 2381",
    d: "M114.387,152.375a5.718,5.718,0,0,1-1.887,4.62,8.07,8.07,0,0,1-5.367,1.6h-1.7v6.654h-3.965V146.541h5.975A7.959,7.959,0,0,1,112.616,148,5.344,5.344,0,0,1,114.387,152.375Zm-8.957,2.969h1.305a4.355,4.355,0,0,0,2.739-.721,2.534,2.534,0,0,0,.909-2.107,2.6,2.6,0,0,0-.76-2.06,3.573,3.573,0,0,0-2.387-.666H105.43Z",
    transform: "translate(-6.813 -146.271)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2382",
    "data-name": "Path 2382",
    d: "M120.382,165.3l-1.358-4.452H112.2l-1.355,4.452h-4.274l6.6-18.785h4.851l6.628,18.785Zm-2.3-7.778q-1.883-6.058-2.12-6.848c-.157-.529-.273-.946-.338-1.253q-.421,1.639-2.419,8.1Z",
    transform: "translate(1.467 -146.32)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2383",
    "data-name": "Path 2383",
    d: "M122.807,149.74a4.051,4.051,0,0,0-3.47,1.68,7.852,7.852,0,0,0-1.226,4.691q0,6.258,4.7,6.258a14.809,14.809,0,0,0,4.772-.985v3.328a13.26,13.26,0,0,1-5.144.959,7.85,7.85,0,0,1-6.245-2.476q-2.162-2.473-2.162-7.107a11.646,11.646,0,0,1,1.061-5.113,7.719,7.719,0,0,1,3.053-3.368,9.052,9.052,0,0,1,4.665-1.169,12.605,12.605,0,0,1,5.477,1.318L127,150.98a21.311,21.311,0,0,0-2.11-.87A6.327,6.327,0,0,0,122.807,149.74Z",
    transform: "translate(13.548 -146.438)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2384",
    "data-name": "Path 2384",
    d: "M65.347,170.178v-13.1H66.87v13.1Z",
    transform: "translate(-65.347 -129.186)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2385",
    "data-name": "Path 2385",
    d: "M73.647,163.433H78.1V169.8a14.6,14.6,0,0,1-2.115.5,16.179,16.179,0,0,1-2.49.168,6.027,6.027,0,0,1-4.628-1.766,6.974,6.974,0,0,1-1.659-4.958,7.479,7.479,0,0,1,.82-3.58,5.52,5.52,0,0,1,2.361-2.348A7.636,7.636,0,0,1,74,157.012a9.858,9.858,0,0,1,3.9.768l-.592,1.344a8.726,8.726,0,0,0-3.409-.752,4.892,4.892,0,0,0-3.737,1.423,5.535,5.535,0,0,0-1.344,3.952,5.647,5.647,0,0,0,1.295,4.02,4.98,4.98,0,0,0,3.8,1.371,11.257,11.257,0,0,0,2.66-.312v-4.033H73.647Z",
    transform: "translate(-62.336 -129.301)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2386",
    "data-name": "Path 2386",
    d: "M82.229,170.211l-1.63-4.167H75.35l-1.612,4.167H72.2l5.178-13.148h1.282l5.15,13.148Zm-2.1-5.535L78.6,160.619c-.2-.514-.4-1.145-.608-1.892a17.314,17.314,0,0,1-.566,1.892l-1.541,4.057Z",
    transform: "translate(-54.246 -129.219)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2387",
    "data-name": "Path 2387",
    d: "M88.021,163.5a6.609,6.609,0,0,1-1.761,4.961,6.958,6.958,0,0,1-5.063,1.714h-3.63v-13.1h4.012a5.879,5.879,0,0,1,6.442,6.421Zm-1.612.058a5.281,5.281,0,0,0-1.284-3.863,5.16,5.16,0,0,0-3.821-1.3H79.09v10.462h1.855a5.635,5.635,0,0,0,4.093-1.342A5.3,5.3,0,0,0,86.409,163.561Z",
    transform: "translate(-45.543 -129.186)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2388",
    "data-name": "Path 2388",
    d: "M90.519,158.372a4.283,4.283,0,0,0-3.409,1.436,5.786,5.786,0,0,0-1.25,3.939,5.942,5.942,0,0,0,1.2,3.973,4.294,4.294,0,0,0,3.438,1.4,11.762,11.762,0,0,0,3.124-.5v1.334a9.545,9.545,0,0,1-3.357.511,5.684,5.684,0,0,1-4.466-1.753,7.22,7.22,0,0,1-1.572-4.992,7.892,7.892,0,0,1,.755-3.546,5.456,5.456,0,0,1,2.186-2.345,6.623,6.623,0,0,1,3.365-.823,8.1,8.1,0,0,1,3.6.752l-.645,1.305A6.928,6.928,0,0,0,90.519,158.372Z",
    transform: "translate(-34.746 -129.301)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2389",
    "data-name": "Path 2389",
    d: "M90.489,170.7H89V156.761h1.486Z",
    transform: "translate(-27.009 -129.708)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2390",
    "data-name": "Path 2390",
    d: "M90.848,157.926a1,1,0,0,1,.252-.747.935.935,0,0,1,1.247.005.979.979,0,0,1,.257.742,1,1,0,0,1-.257.752.88.88,0,0,1-.621.244.87.87,0,0,1-.626-.244A1.025,1.025,0,0,1,90.848,157.926Zm1.614,12.48H90.974v-9.817h1.489Z",
    transform: "translate(-24.019 -129.413)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2391",
    "data-name": "Path 2391",
    d: "M105.3,168.261v-6.387a2.656,2.656,0,0,0-.5-1.758,1.937,1.937,0,0,0-1.559-.587,2.518,2.518,0,0,0-2.052.8,3.793,3.793,0,0,0-.663,2.453v5.482H99.043v-6.387a2.642,2.642,0,0,0-.5-1.758,1.943,1.943,0,0,0-1.567-.587,2.436,2.436,0,0,0-2.047.836,4.536,4.536,0,0,0-.65,2.746v5.15H92.79v-9.817H94l.239,1.344h.073A2.9,2.9,0,0,1,95.5,158.67a3.574,3.574,0,0,1,1.714-.4,2.92,2.92,0,0,1,3.011,1.664h.071a3.128,3.128,0,0,1,1.271-1.216,3.921,3.921,0,0,1,1.9-.448,3.321,3.321,0,0,1,2.495.854,3.83,3.83,0,0,1,.831,2.739v6.4Z",
    transform: "translate(-20.872 -127.269)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2392",
    "data-name": "Path 2392",
    d: "M105.916,168.25l-.293-1.4h-.071a4.139,4.139,0,0,1-1.468,1.247,4.466,4.466,0,0,1-1.821.328,3.272,3.272,0,0,1-2.288-.752,2.737,2.737,0,0,1-.831-2.138q0-2.976,4.759-3.116l1.664-.058v-.608a2.485,2.485,0,0,0-.5-1.706,2.04,2.04,0,0,0-1.588-.553,6.507,6.507,0,0,0-2.778.752l-.456-1.135a7.049,7.049,0,0,1,1.591-.621,6.977,6.977,0,0,1,1.732-.22,3.732,3.732,0,0,1,2.6.778,3.253,3.253,0,0,1,.846,2.5v6.7Zm-3.357-1.048a3.026,3.026,0,0,0,2.18-.76,2.827,2.827,0,0,0,.794-2.133v-.886l-1.489.063a5.394,5.394,0,0,0-2.558.55,1.661,1.661,0,0,0-.784,1.517,1.534,1.534,0,0,0,.49,1.229A2.021,2.021,0,0,0,102.559,167.2Z",
    transform: "translate(-10.574 -127.258)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2393",
    "data-name": "Path 2393",
    d: "M107.463,168.509a4.778,4.778,0,0,0,.76-.058,4.069,4.069,0,0,0,.584-.123v1.14a2.793,2.793,0,0,1-.713.191,5.158,5.158,0,0,1-.846.076q-2.85,0-2.849-3V160.9h-1.407v-.715l1.407-.618.626-2.1h.86v2.275h2.849V160.9h-2.849v5.779a1.989,1.989,0,0,0,.422,1.36A1.459,1.459,0,0,0,107.463,168.509Z",
    transform: "translate(-4.338 -128.566)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2394",
    "data-name": "Path 2394",
    d: "M110.56,168.439a4.515,4.515,0,0,1-3.436-1.323,5.135,5.135,0,0,1-1.258-3.682,5.694,5.694,0,0,1,1.169-3.771,3.882,3.882,0,0,1,3.14-1.4,3.708,3.708,0,0,1,2.922,1.213,4.654,4.654,0,0,1,1.074,3.2v.941h-6.764a3.9,3.9,0,0,0,.875,2.623,3.01,3.01,0,0,0,2.33.894,7.933,7.933,0,0,0,3.137-.66v1.326a7.82,7.82,0,0,1-1.491.487A8.32,8.32,0,0,1,110.56,168.439Zm-.4-8.931a2.432,2.432,0,0,0-1.887.773,3.549,3.549,0,0,0-.828,2.131h5.131a3.279,3.279,0,0,0-.626-2.154A2.209,2.209,0,0,0,110.159,159.508Z",
    transform: "translate(0.32 -127.269)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2395",
    "data-name": "Path 2395",
    d: "M120.208,160.9a3.667,3.667,0,0,1-1.357,3.058,6.127,6.127,0,0,1-3.881,1.072h-1.541v5.15h-1.523v-13.1H115.3Q120.21,157.083,120.208,160.9Zm-6.78,2.82H114.8a5.113,5.113,0,0,0,2.932-.653,2.412,2.412,0,0,0,.9-2.1,2.262,2.262,0,0,0-.849-1.934,4.448,4.448,0,0,0-2.652-.634h-1.7Z",
    transform: "translate(10.109 -129.186)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2396",
    "data-name": "Path 2396",
    d: "M120.625,158.266a5.689,5.689,0,0,1,1.174.107l-.207,1.378a5.077,5.077,0,0,0-1.074-.136,2.613,2.613,0,0,0-2.036.967,3.527,3.527,0,0,0-.847,2.411v5.267h-1.488v-9.817h1.229l.168,1.816h.073a4.3,4.3,0,0,1,1.318-1.475A2.957,2.957,0,0,1,120.625,158.266Z",
    transform: "translate(16.98 -127.269)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2397",
    "data-name": "Path 2397",
    d: "M123.6,168.439a4.515,4.515,0,0,1-3.436-1.323,5.135,5.135,0,0,1-1.258-3.682,5.694,5.694,0,0,1,1.169-3.771,3.882,3.882,0,0,1,3.14-1.4,3.708,3.708,0,0,1,2.922,1.213,4.654,4.654,0,0,1,1.074,3.2v.941h-6.764a3.9,3.9,0,0,0,.875,2.623,3.01,3.01,0,0,0,2.33.894,7.933,7.933,0,0,0,3.137-.66v1.326a7.821,7.821,0,0,1-1.491.487A8.32,8.32,0,0,1,123.6,168.439Zm-.4-8.931a2.432,2.432,0,0,0-1.887.773,3.549,3.549,0,0,0-.828,2.131h5.134a3.279,3.279,0,0,0-.629-2.154A2.209,2.209,0,0,0,123.2,159.508Z",
    transform: "translate(21.455 -127.269)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2398",
    "data-name": "Path 2398",
    d: "M130.246,169.385h-.079a3.5,3.5,0,0,1-3.082,1.494,3.655,3.655,0,0,1-3-1.313,5.813,5.813,0,0,1-1.069-3.748,5.9,5.9,0,0,1,1.074-3.771,3.624,3.624,0,0,1,2.993-1.342,3.57,3.57,0,0,1,3.064,1.449h.115l-.063-.708-.034-.689v-4h1.486V170.7h-1.211Zm-2.974.252a2.709,2.709,0,0,0,2.209-.831,4.182,4.182,0,0,0,.687-2.673v-.314a4.919,4.919,0,0,0-.7-2.977,2.639,2.639,0,0,0-2.217-.894,2.275,2.275,0,0,0-2,1.019,5.046,5.046,0,0,0-.694,2.872,4.855,4.855,0,0,0,.689,2.838A2.336,2.336,0,0,0,127.271,169.636Z",
    transform: "translate(28.117 -129.708)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2399",
    "data-name": "Path 2399",
    d: "M127.6,157.926a1,1,0,0,1,.252-.747.935.935,0,0,1,1.247.005.979.979,0,0,1,.257.742,1,1,0,0,1-.257.752.88.88,0,0,1-.621.244.87.87,0,0,1-.626-.244A1.025,1.025,0,0,1,127.6,157.926Zm1.614,12.48h-1.489v-9.817h1.489Z",
    transform: "translate(35.535 -129.413)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2400",
    "data-name": "Path 2400",
    d: "M133.814,168.439a4.2,4.2,0,0,1-3.3-1.31,5.4,5.4,0,0,1-1.169-3.713,5.57,5.57,0,0,1,1.187-3.808,4.281,4.281,0,0,1,3.383-1.342,6.7,6.7,0,0,1,1.415.152,4.567,4.567,0,0,1,1.111.359l-.459,1.261a7.625,7.625,0,0,0-1.074-.328,4.809,4.809,0,0,0-1.03-.128q-3,0-2.993,3.818a4.526,4.526,0,0,0,.731,2.773,2.537,2.537,0,0,0,2.162.967,6.591,6.591,0,0,0,2.518-.527v1.316A5.336,5.336,0,0,1,133.814,168.439Z",
    transform: "translate(38.368 -127.269)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2401",
    "data-name": "Path 2401",
    d: "M137.235,168.509a4.754,4.754,0,0,0,.76-.058,4.072,4.072,0,0,0,.584-.123v1.14a2.738,2.738,0,0,1-.71.191,5.188,5.188,0,0,1-.849.076q-2.846,0-2.849-3V160.9h-1.407v-.715l1.407-.618.629-2.1h.86v2.275h2.849V160.9H135.66v5.779a2,2,0,0,0,.419,1.36A1.462,1.462,0,0,0,137.235,168.509Z",
    transform: "translate(43.912 -128.566)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2402",
    "data-name": "Path 2402",
    d: "M135.877,157.926a1,1,0,0,1,.249-.747.935.935,0,0,1,1.247.005.98.98,0,0,1,.259.742,1.006,1.006,0,0,1-.259.752.92.92,0,0,1-1.247,0A1.024,1.024,0,0,1,135.877,157.926Zm1.612,12.48H136v-9.817h1.486Z",
    transform: "translate(48.957 -129.413)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2403",
    "data-name": "Path 2403",
    d: "M146.631,163.342a5.409,5.409,0,0,1-1.208,3.75,4.253,4.253,0,0,1-3.341,1.347,4.407,4.407,0,0,1-2.338-.618,4.075,4.075,0,0,1-1.575-1.772,6.165,6.165,0,0,1-.556-2.707,5.4,5.4,0,0,1,1.2-3.74,4.248,4.248,0,0,1,3.333-1.337,4.153,4.153,0,0,1,3.273,1.371A5.394,5.394,0,0,1,146.631,163.342Zm-7.477,0a4.663,4.663,0,0,0,.752,2.867,2.978,2.978,0,0,0,4.426.005,4.606,4.606,0,0,0,.76-2.872,4.54,4.54,0,0,0-.76-2.843,2.654,2.654,0,0,0-2.233-.97,2.62,2.62,0,0,0-2.2.957A4.636,4.636,0,0,0,139.154,163.342Z",
    transform: "translate(51.771 -127.269)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2404",
    "data-name": "Path 2404",
    d: "M148.914,168.261v-6.352a2.575,2.575,0,0,0-.545-1.79,2.228,2.228,0,0,0-1.714-.59,2.829,2.829,0,0,0-2.256.831,4.214,4.214,0,0,0-.718,2.752v5.15h-1.486v-9.817h1.211l.241,1.344h.071A3.032,3.032,0,0,1,145,158.664a4.142,4.142,0,0,1,1.837-.4,3.717,3.717,0,0,1,2.668.854,3.634,3.634,0,0,1,.9,2.739v6.4Z",
    transform: "translate(59.196 -127.269)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2405",
    "data-name": "Path 2405",
    d: "M69.133,175.315a3.544,3.544,0,0,1,.621-2.065,6.737,6.737,0,0,1,2.233-1.806,10.969,10.969,0,0,1-1.033-1.289,4.509,4.509,0,0,1-.435-.917,3.031,3.031,0,0,1-.163-.983,2.631,2.631,0,0,1,.878-2.1,3.651,3.651,0,0,1,2.448-.752,3.3,3.3,0,0,1,2.283.75,2.659,2.659,0,0,1,.833,2.081,2.9,2.9,0,0,1-.608,1.772,6.9,6.9,0,0,1-2.018,1.643l3.648,3.5a4.39,4.39,0,0,0,.8-1.3,11.329,11.329,0,0,0,.506-1.635h1.5A8.551,8.551,0,0,1,78.8,176.1l2.681,2.608H79.422l-1.656-1.6a6.345,6.345,0,0,1-4.586,1.774,4.335,4.335,0,0,1-2.988-.949A3.342,3.342,0,0,1,69.133,175.315Zm4.083,2.235a4.948,4.948,0,0,0,3.582-1.376l-3.915-3.8a8.594,8.594,0,0,0-1.4,1,2.607,2.607,0,0,0-.608.857,2.559,2.559,0,0,0-.2,1.04,2.107,2.107,0,0,0,.694,1.661A2.694,2.694,0,0,0,73.216,177.551Zm-1.389-9.329a2.334,2.334,0,0,0,.322,1.177,7.173,7.173,0,0,0,1.1,1.344,5.757,5.757,0,0,0,1.606-1.237,2.054,2.054,0,0,0,.453-1.313,1.467,1.467,0,0,0-.464-1.124,1.724,1.724,0,0,0-1.232-.435,1.92,1.92,0,0,0-1.295.43A1.456,1.456,0,0,0,71.827,168.221Z",
    transform: "translate(-59.211 -115.701)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2406",
    "data-name": "Path 2406",
    d: "M85.707,178.613l-1.63-4.167H78.828l-1.614,4.167H75.675l5.176-13.15H82.13l5.152,13.15ZM83.6,173.076l-1.523-4.057c-.2-.514-.4-1.143-.611-1.889a17.182,17.182,0,0,1-.561,1.889l-1.541,4.057Z",
    transform: "translate(-48.609 -115.605)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2407",
    "data-name": "Path 2407",
    d: "M85.55,176.842a4.248,4.248,0,0,1-1.751-.354,3.251,3.251,0,0,1-1.329-1.09h-.107a13.389,13.389,0,0,1,.107,1.633v4.038H80.982V166.844H82.19l.207,1.344h.073a3.438,3.438,0,0,1,1.331-1.164,4.077,4.077,0,0,1,1.748-.359A3.637,3.637,0,0,1,88.566,168a7.119,7.119,0,0,1-.018,7.5A3.639,3.639,0,0,1,85.55,176.842Zm-.215-8.913a2.637,2.637,0,0,0-2.178.833,4.26,4.26,0,0,0-.687,2.652v.33a4.911,4.911,0,0,0,.687,2.959,2.626,2.626,0,0,0,2.214.894,2.313,2.313,0,0,0,1.994-1.03,4.91,4.91,0,0,0,.718-2.838,4.722,4.722,0,0,0-.718-2.817A2.378,2.378,0,0,0,85.335,167.929Z",
    transform: "translate(-40.008 -113.656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2408",
    "data-name": "Path 2408",
    d: "M89.99,176.842a4.248,4.248,0,0,1-1.751-.354,3.276,3.276,0,0,1-1.331-1.09H86.8a13.389,13.389,0,0,1,.107,1.633v4.038H85.422V166.844h1.211l.2,1.344h.071a3.433,3.433,0,0,1,1.337-1.164,4.057,4.057,0,0,1,1.745-.359A3.625,3.625,0,0,1,93,168a7.1,7.1,0,0,1-.018,7.5A3.627,3.627,0,0,1,89.99,176.842Zm-.215-8.913a2.631,2.631,0,0,0-2.175.833,4.292,4.292,0,0,0-.692,2.652v.33A4.888,4.888,0,0,0,87.6,174.7a2.615,2.615,0,0,0,2.209.894,2.3,2.3,0,0,0,1.994-1.03,4.87,4.87,0,0,0,.723-2.838,4.683,4.683,0,0,0-.723-2.817A2.367,2.367,0,0,0,89.775,167.929Z",
    transform: "translate(-32.813 -113.656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2409",
    "data-name": "Path 2409",
    d: "M91.355,179.1H89.869V165.162h1.486Z",
    transform: "translate(-25.606 -116.093)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2410",
    "data-name": "Path 2410",
    d: "M91.715,166.327a.985.985,0,0,1,.249-.747.931.931,0,0,1,1.245.005.966.966,0,0,1,.259.742.989.989,0,0,1-.259.75.909.909,0,0,1-1.245,0A1.007,1.007,0,0,1,91.715,166.327Zm1.612,12.48H91.838v-9.82h1.489Z",
    transform: "translate(-22.614 -115.798)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2411",
    "data-name": "Path 2411",
    d: "M97.933,176.842a4.191,4.191,0,0,1-3.3-1.313,5.4,5.4,0,0,1-1.169-3.713,5.563,5.563,0,0,1,1.187-3.805,4.272,4.272,0,0,1,3.381-1.344,6.667,6.667,0,0,1,1.415.155,4.617,4.617,0,0,1,1.111.356l-.456,1.263a7.174,7.174,0,0,0-1.074-.328,4.85,4.85,0,0,0-1.033-.131Q95,167.982,95,171.8a4.517,4.517,0,0,0,.731,2.775,2.534,2.534,0,0,0,2.162.967,6.628,6.628,0,0,0,2.516-.527v1.316A5.351,5.351,0,0,1,97.933,176.842Z",
    transform: "translate(-19.783 -113.656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2412",
    "data-name": "Path 2412",
    d: "M103.732,176.652l-.3-1.4h-.071a4.1,4.1,0,0,1-1.468,1.25,4.457,4.457,0,0,1-1.821.328,3.285,3.285,0,0,1-2.288-.752,2.746,2.746,0,0,1-.828-2.141q0-2.972,4.757-3.116l1.667-.058v-.608a2.472,2.472,0,0,0-.5-1.7,2.031,2.031,0,0,0-1.588-.553,6.468,6.468,0,0,0-2.778.752l-.453-1.137a6.978,6.978,0,0,1,1.588-.618,6.877,6.877,0,0,1,1.732-.223,3.728,3.728,0,0,1,2.6.781,3.246,3.246,0,0,1,.849,2.5v6.7Zm-3.36-1.051a3.025,3.025,0,0,0,2.18-.76,2.811,2.811,0,0,0,.794-2.131v-.886l-1.486.06a5.438,5.438,0,0,0-2.56.55,1.664,1.664,0,0,0-.784,1.517,1.539,1.539,0,0,0,.49,1.229A2.026,2.026,0,0,0,100.372,175.6Z",
    transform: "translate(-14.113 -113.644)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2413",
    "data-name": "Path 2413",
    d: "M105.276,176.909a5.123,5.123,0,0,0,.763-.055,5,5,0,0,0,.582-.123v1.137a2.723,2.723,0,0,1-.71.194,5.524,5.524,0,0,1-.849.076q-2.846,0-2.849-3V169.3h-1.4v-.718l1.4-.618.629-2.1h.86v2.275h2.849V169.3H103.7v5.776a1.984,1.984,0,0,0,.422,1.36A1.448,1.448,0,0,0,105.276,176.909Z",
    transform: "translate(-7.877 -114.952)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2414",
    "data-name": "Path 2414",
    d: "M103.92,166.327a1,1,0,0,1,.249-.747.935.935,0,0,1,1.247.005.976.976,0,0,1,.259.742,1,1,0,0,1-.259.75.913.913,0,0,1-1.247,0A1.018,1.018,0,0,1,103.92,166.327Zm1.612,12.48h-1.486v-9.82h1.486Z",
    transform: "translate(-2.834 -115.798)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2415",
    "data-name": "Path 2415",
    d: "M114.674,171.745a5.406,5.406,0,0,1-1.208,3.748,4.255,4.255,0,0,1-3.341,1.35,4.407,4.407,0,0,1-2.338-.618,4.089,4.089,0,0,1-1.575-1.772,6.173,6.173,0,0,1-.556-2.707,5.4,5.4,0,0,1,1.2-3.74,4.239,4.239,0,0,1,3.331-1.339,4.139,4.139,0,0,1,3.273,1.373A5.377,5.377,0,0,1,114.674,171.745Zm-7.477,0a4.66,4.66,0,0,0,.752,2.864,2.978,2.978,0,0,0,4.426.005,4.6,4.6,0,0,0,.757-2.87,4.535,4.535,0,0,0-.757-2.843,2.655,2.655,0,0,0-2.233-.972,2.621,2.621,0,0,0-2.2.959A4.631,4.631,0,0,0,107.2,171.745Z",
    transform: "translate(-0.02 -113.656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2416",
    "data-name": "Path 2416",
    d: "M116.956,176.664v-6.352a2.553,2.553,0,0,0-.548-1.793,2.221,2.221,0,0,0-1.709-.59,2.814,2.814,0,0,0-2.256.833,4.194,4.194,0,0,0-.718,2.752v5.15h-1.486v-9.82h1.208l.244,1.344h.071a3.058,3.058,0,0,1,1.279-1.124,4.187,4.187,0,0,1,1.837-.4,3.724,3.724,0,0,1,2.67.854,3.648,3.648,0,0,1,.9,2.739v6.4Z",
    transform: "translate(7.407 -113.656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2417",
    "data-name": "Path 2417",
    d: "M121.38,173.985a2.465,2.465,0,0,1-1.022,2.115,4.824,4.824,0,0,1-2.864.742,6.211,6.211,0,0,1-3.048-.618v-1.378a7.479,7.479,0,0,0,1.517.563,6.294,6.294,0,0,0,1.565.2,3.571,3.571,0,0,0,1.793-.37,1.28,1.28,0,0,0,.128-2.115,7.743,7.743,0,0,0-1.939-.962,10.678,10.678,0,0,1-1.95-.891,2.7,2.7,0,0,1-.86-.865,2.281,2.281,0,0,1-.28-1.156,2.2,2.2,0,0,1,.978-1.895,4.536,4.536,0,0,1,2.676-.694,7.836,7.836,0,0,1,3.1.645l-.527,1.208a7.164,7.164,0,0,0-2.681-.608,3.085,3.085,0,0,0-1.593.333,1.02,1.02,0,0,0-.537.912,1.1,1.1,0,0,0,.2.674,1.974,1.974,0,0,0,.65.527,14.1,14.1,0,0,0,1.719.729,6.434,6.434,0,0,1,2.361,1.279A2.259,2.259,0,0,1,121.38,173.985Z",
    transform: "translate(14.183 -113.656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2418",
    "data-name": "Path 2418",
    d: "M125.932,166.775a4.273,4.273,0,0,0-3.407,1.436,5.8,5.8,0,0,0-1.253,3.936,5.919,5.919,0,0,0,1.205,3.973,4.284,4.284,0,0,0,3.436,1.4,11.766,11.766,0,0,0,3.126-.493v1.334a9.611,9.611,0,0,1-3.36.511,5.683,5.683,0,0,1-4.463-1.756,7.226,7.226,0,0,1-1.575-4.99,7.9,7.9,0,0,1,.757-3.548,5.434,5.434,0,0,1,2.186-2.343,6.61,6.61,0,0,1,3.365-.826,8.131,8.131,0,0,1,3.6.752l-.647,1.305A6.936,6.936,0,0,0,125.932,166.775Z",
    transform: "translate(22.646 -115.688)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2419",
    "data-name": "Path 2419",
    d: "M128.8,176.842a4.516,4.516,0,0,1-3.436-1.326,5.133,5.133,0,0,1-1.258-3.679,5.7,5.7,0,0,1,1.169-3.774,3.886,3.886,0,0,1,3.14-1.4,3.7,3.7,0,0,1,2.919,1.213,4.652,4.652,0,0,1,1.074,3.205v.938h-6.761a3.884,3.884,0,0,0,.873,2.623,3.014,3.014,0,0,0,2.335.9,7.93,7.93,0,0,0,3.134-.66v1.326a7.922,7.922,0,0,1-1.491.485A8.3,8.3,0,0,1,128.8,176.842Zm-.4-8.931a2.427,2.427,0,0,0-1.887.773,3.533,3.533,0,0,0-.825,2.128h5.131a3.256,3.256,0,0,0-.626-2.152A2.2,2.2,0,0,0,128.392,167.911Z",
    transform: "translate(29.874 -113.656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2420",
    "data-name": "Path 2420",
    d: "M135.106,176.664v-6.352a2.565,2.565,0,0,0-.545-1.793,2.235,2.235,0,0,0-1.711-.59,2.827,2.827,0,0,0-2.259.833,4.225,4.225,0,0,0-.715,2.752v5.15h-1.489v-9.82H129.6l.241,1.344h.071a3.073,3.073,0,0,1,1.284-1.124,4.167,4.167,0,0,1,1.834-.4,3.717,3.717,0,0,1,2.668.854,3.638,3.638,0,0,1,.9,2.739v6.4Z",
    transform: "translate(36.819 -113.656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2421",
    "data-name": "Path 2421",
    d: "M136.815,176.909a5.123,5.123,0,0,0,.763-.055,5.005,5.005,0,0,0,.582-.123v1.137a2.724,2.724,0,0,1-.71.194,5.5,5.5,0,0,1-.849.076q-2.846,0-2.846-3V169.3h-1.407v-.718l1.407-.618.626-2.1h.86v2.275h2.849V169.3H135.24v5.776a1.984,1.984,0,0,0,.422,1.36A1.448,1.448,0,0,0,136.815,176.909Z",
    transform: "translate(43.236 -114.952)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2422",
    "data-name": "Path 2422",
    d: "M139.986,166.666a5.866,5.866,0,0,1,1.171.107l-.2,1.378a5.117,5.117,0,0,0-1.074-.134,2.614,2.614,0,0,0-2.039.967,3.522,3.522,0,0,0-.846,2.411v5.268h-1.486v-9.82h1.224l.173,1.819h.071a4.355,4.355,0,0,1,1.316-1.478A2.967,2.967,0,0,1,139.986,166.666Z",
    transform: "translate(48.358 -113.656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2423",
    "data-name": "Path 2423",
    d: "M142.964,176.842a4.516,4.516,0,0,1-3.436-1.326,5.133,5.133,0,0,1-1.258-3.679,5.7,5.7,0,0,1,1.169-3.774,3.886,3.886,0,0,1,3.14-1.4,3.7,3.7,0,0,1,2.919,1.213,4.665,4.665,0,0,1,1.074,3.205v.938h-6.761a3.884,3.884,0,0,0,.873,2.623,3.014,3.014,0,0,0,2.335.9,7.93,7.93,0,0,0,3.134-.66v1.326a7.922,7.922,0,0,1-1.491.485A8.3,8.3,0,0,1,142.964,176.842Zm-.4-8.931a2.427,2.427,0,0,0-1.887.773,3.533,3.533,0,0,0-.826,2.128h5.131a3.256,3.256,0,0,0-.626-2.152A2.2,2.2,0,0,0,142.56,167.911Z",
    transform: "translate(52.835 -113.656)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_905",
    "data-name": "Group 905",
    transform: "translate(73.571 59.779)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2424",
    "data-name": "Path 2424",
    d: "M66.883,85.942l.351-1.357,7.322,1.884-.349,1.357Z",
    transform: "translate(-66.883 -7.446)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2425",
    "data-name": "Path 2425",
    d: "M67.2,87.455l.48-1.5L73.9,84.625l-5.268-1.675.427-1.337,7.207,2.293L75.8,85.39l-6.208,1.352,5.247,1.669-.425,1.337Z",
    transform: "translate(-66.364 -12.261)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2426",
    "data-name": "Path 2426",
    d: "M69.876,82.733l-.506,1.3-1.268-.5,1.528-3.918,1.268.493-.514,1.316,5.779,2.251-.508,1.308Z",
    transform: "translate(-64.907 -15.498)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2427",
    "data-name": "Path 2427",
    d: "M68.867,81.477l1.667-3.7,1.242.558-1.093,2.427,1.585.713,1.046-2.322,1.242.558L73.511,82.03l1.585.715,1.093-2.427,1.24.558-1.667,3.706Z",
    transform: "translate(-63.668 -18.484)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2428",
    "data-name": "Path 2428",
    d: "M69.807,79.381l1.019-1.939A2.892,2.892,0,0,1,72.21,75.95a2.475,2.475,0,0,1,2.057.086,2.689,2.689,0,0,1,1.169,1.318,2.506,2.506,0,0,1,.021,1.525l3.423-.516-.8,1.533-3.488.411,2.566,1.344L76.5,82.895Zm4.2-.246A1.649,1.649,0,0,0,74.241,78a1.1,1.1,0,0,0-.563-.689,1.052,1.052,0,0,0-.941-.031,1.52,1.52,0,0,0-.713.8l-.359.689,1.984,1.04Z",
    transform: "translate(-62.144 -21.737)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2429",
    "data-name": "Path 2429",
    d: "M75.111,74.47a2.5,2.5,0,0,0-1.9,1.15,2.592,2.592,0,0,0,.778,3.58,2.627,2.627,0,0,0,1.876.317,2.7,2.7,0,0,0,1.756-1.206,2.561,2.561,0,0,0,.021-2.594L75.96,78.4l-1.116-.7,2.618-4.18.136.086a4.033,4.033,0,0,1-4.314,6.811A4,4,0,0,1,72.056,74.9,3.957,3.957,0,0,1,76,73.05Z",
    transform: "translate(-59.5 -26.232)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2430",
    "data-name": "Path 2430",
    d: "M79.712,71.035a3.938,3.938,0,1,1-5.535.742A3.937,3.937,0,0,1,79.712,71.035Zm-3.939,5.139a2.538,2.538,0,1,0,3.069-4.041,2.537,2.537,0,1,0-3.069,4.041Z",
    transform: "translate(-56.362 -30.726)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2431",
    "data-name": "Path 2431",
    d: "M74.924,72.539l.985-1.1,5.64,2.325-2.922-5.354.985-1.1,3.674,7.228-.773.862Z",
    transform: "translate(-53.851 -35.438)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2432",
    "data-name": "Path 2432",
    d: "M77.085,68.711l2.906-2.841.949.972L79.04,68.7l1.213,1.245,1.824-1.782.951.972L81.207,70.92l1.216,1.242,1.9-1.858.951.972-2.9,2.841Z",
    transform: "translate(-50.349 -37.777)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2433",
    "data-name": "Path 2433",
    d: "M78.7,66.835,80.356,65.4a2.908,2.908,0,0,1,1.832-.886,2.471,2.471,0,0,1,1.887.831A2.691,2.691,0,0,1,84.682,67a2.456,2.456,0,0,1-.537,1.426l3.378.77-1.308,1.132-3.4-.886,1.9,2.188-1.059.917Zm4,1.3a1.643,1.643,0,0,0,.634-.97,1.117,1.117,0,0,0-.273-.846,1.051,1.051,0,0,0-.867-.372,1.522,1.522,0,0,0-.957.49l-.587.508,1.47,1.693Z",
    transform: "translate(-47.729 -39.976)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2434",
    "data-name": "Path 2434",
    d: "M80.6,66.048l1.261-.946L87.7,67.628,84.384,63.21l1.119-.844,4.542,6.048-1.242.933-5.844-2.5,3.307,4.4-1.122.841Z",
    transform: "translate(-44.649 -43.455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2435",
    "data-name": "Path 2435",
    d: "M83.145,64.471l1.625-1.012L89.545,67.3l-1.308-6L89.851,60.3l4,6.421-1.192.742-2.993-4.814L91,68.491l-1.006.626-4.654-3.779,2.993,4.812-1.19.742Z",
    transform: "translate(-40.528 -46.81)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2436",
    "data-name": "Path 2436",
    d: "M86.371,61.111l3.6-1.876.629,1.208L88.245,61.67l.8,1.544,2.259-1.177.629,1.208-2.259,1.177.8,1.541,2.361-1.226.626,1.205-3.6,1.876Z",
    transform: "translate(-35.3 -48.53)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2437",
    "data-name": "Path 2437",
    d: "M88.383,60.43,89.83,59.8l5.1,3.805-2.209-5.066L94,57.98l3.024,6.932-1.426.621-5.108-3.776,2.2,5.045-1.284.561Z",
    transform: "translate(-32.039 -50.564)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2438",
    "data-name": "Path 2438",
    d: "M92.8,59.485l-1.308.477-.466-1.279,3.952-1.439.466,1.282-1.329.482,2.118,5.826-1.316.48Z",
    transform: "translate(-27.754 -51.756)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2439",
    "data-name": "Path 2439",
    d: "M94.172,57.085l1.051-.314,5.226,6.326-1.481.443L97.62,61.9l-2.566.773-.241,2.112-1.481.446ZM96.7,60.762,95.264,58.8l-.113,2.427Z",
    transform: "translate(-24.017 -52.523)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2440",
    "data-name": "Path 2440",
    d: "M95.721,56.511l1.365-.317,1.4,6.038,2.254-.522.307,1.326-3.616.839Z",
    transform: "translate(-20.147 -53.458)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2441",
    "data-name": "Path 2441",
    d: "M101.116,55.623l1.085-.144,4.151,7.078-1.533.2-1.069-1.829-2.657.354-.574,2.047-1.533.2Zm1.908,4.031-1.1-2.167-.5,2.38Z",
    transform: "translate(-14.857 -54.617)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2442",
    "data-name": "Path 2442",
    d: "M103.355,55.385l.27,4.709a2.127,2.127,0,0,0,.2,1.014,1.127,1.127,0,0,0,1.038.587,1.157,1.157,0,0,0,.92-.587,2.052,2.052,0,0,0,.139-1.145l-.27-4.709,1.4-.081.27,4.709a3.017,3.017,0,0,1-.435,2.076,2.515,2.515,0,0,1-3.928.288,2.9,2.9,0,0,1-.734-2.07l-.273-4.709Z",
    transform: "translate(-10.047 -55.113)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2443",
    "data-name": "Path 2443",
    d: "M105.787,56.557l-1.392.021-.021-1.36,4.2-.068.024,1.36-1.413.024.1,6.2-1.4.024Z",
    transform: "translate(-6.123 -55.15)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2444",
    "data-name": "Path 2444",
    d: "M106.779,55.169l1.4.081L108,58.274l2.7.157.178-3.024,1.4.084-.443,7.547-1.4-.081.186-3.166-2.7-.16-.186,3.168-1.4-.081Z",
    transform: "translate(-2.939 -55.119)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2445",
    "data-name": "Path 2445",
    d: "M116.894,59.993a3.94,3.94,0,1,1-3.347-4.473A3.94,3.94,0,0,1,116.894,59.993Zm-6.407-.938a2.538,2.538,0,1,0,5.024.71,2.537,2.537,0,1,0-5.024-.71Z",
    transform: "translate(1.46 -54.615)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2446",
    "data-name": "Path 2446",
    d: "M113.918,55.9l2.138.472a2.907,2.907,0,0,1,1.806.943,2.469,2.469,0,0,1,.456,2.007,2.684,2.684,0,0,1-.964,1.475,2.487,2.487,0,0,1-1.465.419l1.394,3.171-1.688-.375-1.313-3.255-.626,2.828-1.368-.3Zm1.342,3.983a1.645,1.645,0,0,0,1.158-.068,1.1,1.1,0,0,0,.516-.723,1.051,1.051,0,0,0-.217-.92,1.509,1.509,0,0,0-.962-.474l-.76-.168-.485,2.188Z",
    transform: "translate(6.702 -53.93)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2447",
    "data-name": "Path 2447",
    d: "M116.518,56.46l1.355.37-1.981,7.3-1.352-.367Z",
    transform: "translate(10.351 -53.027)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2448",
    "data-name": "Path 2448",
    d: "M117.782,58.443l-1.329-.417.409-1.3,4.012,1.258-.409,1.3-1.347-.425-1.855,5.917-1.337-.419Z",
    transform: "translate(12.6 -52.591)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2449",
    "data-name": "Path 2449",
    d: "M118.889,62.611l-.639-5.338,1.444.545.312,3.837,2.773-2.67,1.434.542-4.01,3.58-.988,2.615-1.313-.5Z",
    transform: "translate(15.799 -51.709)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2450",
    "data-name": "Path 2450",
    d: "M128.4,64.983a3.94,3.94,0,1,1-1.709-5.317A3.94,3.94,0,0,1,128.4,64.983Zm-5.755-2.972a2.538,2.538,0,1,0,4.521,2.306,2.538,2.538,0,1,0-4.521-2.306Z",
    transform: "translate(20.739 -48.533)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2451",
    "data-name": "Path 2451",
    d: "M127.521,60.482l1.337.831-.244,6.358,2.919-4.691,1.19.739-3.994,6.421-1.321-.82.215-6.35-2.909,4.673-1.19-.739Z",
    transform: "translate(24.914 -46.509)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2452",
    "data-name": "Path 2452",
    d: "M131.6,62.894l1.247.977a4.747,4.747,0,0,1,1.952,2.652,3.946,3.946,0,0,1-.789,3.113,3.885,3.885,0,0,1-2.8,1.46,4.5,4.5,0,0,1-3.008-1.255l-1.274-1Zm-2.587,5.852a3.421,3.421,0,0,0,2.023.936,2.338,2.338,0,0,0,1.871-.912,2.4,2.4,0,0,0,.448-2.2,3.7,3.7,0,0,0-1.413-1.68l-.081-.063-2.985,3.808Z",
    transform: "translate(30.43 -42.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2453",
    "data-name": "Path 2453",
    d: "M134.137,64.748l3.024,2.712-.909,1.014L134.271,66.7l-1.161,1.295,1.9,1.7-.907,1.014-1.9-1.7-1.161,1.3,1.981,1.774-.909,1.014L129.09,70.38Z",
    transform: "translate(33.933 -39.595)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2454",
    "data-name": "Path 2454",
    d: "M134.594,66.1l1.033,1.053-2.686,5.48,5.535-2.571,1.03,1.053-7.45,3.2-.81-.826Z",
    transform: "translate(37.425 -37.41)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2455",
    "data-name": "Path 2455",
    d: "M138.279,68.4l2.647,3.082-1.033.886-1.732-2.018-1.321,1.132L138.5,73.42l-1.033.886-1.659-1.934-1.321,1.135,1.732,2.018-1.033.888-2.644-3.085Z",
    transform: "translate(39.527 -33.67)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2456",
    "data-name": "Path 2456",
    d: "M139.867,70.108l.857,1.109-4.908,3.789,1.413,1.832-1.077.831-2.272-2.94Z",
    transform: "translate(41.694 -30.908)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2457",
    "data-name": "Path 2457",
    d: "M141.516,79.312a3.941,3.941,0,1,1,1.109-5.477A3.943,3.943,0,0,1,141.516,79.312Zm-3.569-5.406a2.539,2.539,0,1,0,2.817,4.222,2.538,2.538,0,1,0-2.817-4.222Z",
    transform: "translate(44.156 -27.709)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2458",
    "data-name": "Path 2458",
    d: "M136.759,78.326l6.588-3.711.875,1.551a3.373,3.373,0,0,1,.655,1.979,2.3,2.3,0,0,1-1.166,1.808,2.437,2.437,0,0,1-2.125.165,3.508,3.508,0,0,1-1.507-1.737l-.136-.238-2.495,1.4Zm4.5-.629a3.887,3.887,0,0,0,.6.9.965.965,0,0,0,1.148.139.917.917,0,0,0,.427-1.074,4.385,4.385,0,0,0-.459-.938l-.126-.223-1.719.97Z",
    transform: "translate(46.361 -23.604)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2459",
    "data-name": "Path 2459",
    d: "M144.712,76.744l.8,1.737-4.392,4.272,6.111-.569.8,1.727L141.177,87.1l-.59-1.274,5.142-2.385-5.965.613-.5-1.077,4.319-4.159L138.441,81.2l-.59-1.274Z",
    transform: "translate(48.131 -20.154)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2460",
    "data-name": "Path 2460",
    d: "M146.383,80.186l1.42,3.805-1.274.477-.933-2.492-1.627.608.891,2.387-1.276.477-.891-2.387-1.63.608.93,2.492-1.274.477L139.3,82.833Z",
    transform: "translate(50.475 -14.575)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2461",
    "data-name": "Path 2461",
    d: "M147.264,82.308l.448,1.512-4.4,4.594,5.3-1.575.4,1.344-7.249,2.154-.443-1.491,4.374-4.61-5.278,1.57-.4-1.344Z",
    transform: "translate(51.638 -11.136)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2462",
    "data-name": "Path 2462",
    d: "M146.924,86.732l-.312-1.357,1.326-.3.941,4.1-1.326.3-.317-1.376-6.043,1.386-.314-1.368Z",
    transform: "translate(53.037 -6.659)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_906",
    "data-name": "Group 906",
    transform: "translate(69.389 170.213)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2463",
    "data-name": "Path 2463",
    d: "M73.149,99.98l.118,1.088L66.1,105.059l-.168-1.538,1.853-1.027-.294-2.663-2.034-.621-.17-1.536ZM69.076,101.8l2.191-1.053L68.9,100.19Z",
    transform: "translate(-65.287 -96.668)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2464",
    "data-name": "Path 2464",
    d: "M73.217,101.787l-4.641.846a2.175,2.175,0,0,0-.98.325,1.133,1.133,0,0,0-.456,1.1,1.165,1.165,0,0,0,.7.841,2.078,2.078,0,0,0,1.153,0l4.641-.849.252,1.378-4.641.849a3.021,3.021,0,0,1-2.112-.176,2.52,2.52,0,0,1-.77-3.865,2.9,2.9,0,0,1,1.965-.983l4.641-.849Z",
    transform: "translate(-64.506 -92.24)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2465",
    "data-name": "Path 2465",
    d: "M72.271,104.247l-.325-1.352,1.326-.317.98,4.091-1.323.317-.33-1.373-6.03,1.447-.328-1.365Z",
    transform: "translate(-63.741 -88.72)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2466",
    "data-name": "Path 2466",
    d: "M71.948,112.282a3.939,3.939,0,1,1,2.613-4.935A3.939,3.939,0,0,1,71.948,112.282Zm-1.892-6.2a2.539,2.539,0,1,0,1.5,4.848,2.538,2.538,0,1,0-1.5-4.848Z",
    transform: "translate(-62.755 -85.481)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2467",
    "data-name": "Path 2467",
    d: "M74.678,107.42l.8,2.036a2.9,2.9,0,0,1,.223,2.023,2.467,2.467,0,0,1-1.41,1.5A2.7,2.7,0,0,1,72.53,113a2.484,2.484,0,0,1-1.166-.98l-1.85,2.927-.634-1.612,1.971-2.906-2.7,1.059-.511-1.305Zm-2.558,3.336a1.641,1.641,0,0,0,.7.922,1.12,1.12,0,0,0,.891.024,1.052,1.052,0,0,0,.639-.692,1.5,1.5,0,0,0-.144-1.064l-.283-.723-2.086.818Z",
    transform: "translate(-61.47 -80.873)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2468",
    "data-name": "Path 2468",
    d: "M75.435,109.476,76,110.757,69.1,113.832l-.571-1.281Z",
    transform: "translate(-60.041 -77.541)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2469",
    "data-name": "Path 2469",
    d: "M74.7,112.066l-.611-1.25,1.221-.6L77.156,114l-1.224.6-.618-1.268-5.571,2.72-.616-1.258Z",
    transform: "translate(-59.065 -76.338)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2470",
    "data-name": "Path 2470",
    d: "M76.392,112.008l1.958,3.561-1.192.655-1.282-2.332-1.525.839,1.229,2.233-1.192.655-1.229-2.233-1.523.839,1.282,2.332-1.2.655-1.955-3.559Zm1.63-.241,2.3,1.363-.673.988-2.207-1.449Z",
    transform: "translate(-58.027 -73.828)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2471",
    "data-name": "Path 2471",
    d: "M77.751,114.486l.76,1.179-6.36,4.091-.76-1.179Z",
    transform: "translate(-55.395 -69.421)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2472",
    "data-name": "Path 2472",
    d: "M78.169,115.369l.922,1.279-2.644,5.784,4.484-3.226.82,1.137-6.138,4.416L74.7,123.5l2.615-5.792-4.468,3.216-.82-1.137Z",
    transform: "translate(-54.357 -67.99)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2473",
    "data-name": "Path 2473",
    d: "M78.812,119.406l-.878-1.08,1.056-.86,2.655,3.263-1.056.857-.891-1.1-4.809,3.915L74,123.319Z",
    transform: "translate(-51.161 -64.59)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2474",
    "data-name": "Path 2474",
    d: "M80.55,118.883l2.71,3.024-1.012.909-1.777-1.981L79.177,122l1.7,1.9-1.014.907-1.7-1.9-1.295,1.161,1.774,1.981-1.012.909-2.712-3.024Z",
    transform: "translate(-49.679 -62.295)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2475",
    "data-name": "Path 2475",
    d: "M81.7,120.349l1.549,1.546a2.9,2.9,0,0,1,1.017,1.764,2.479,2.479,0,0,1-.692,1.942,2.71,2.71,0,0,1-1.606.726,2.5,2.5,0,0,1-1.462-.432l-.524,3.423L78.755,128.1l.639-3.454-2.047,2.052-.991-.991Zm-1.009,4.083A1.656,1.656,0,0,0,81.7,125a1.111,1.111,0,0,0,.823-.335,1.049,1.049,0,0,0,.312-.891,1.533,1.533,0,0,0-.558-.917l-.55-.55-1.583,1.588Z",
    transform: "translate(-47.346 -59.92)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2476",
    "data-name": "Path 2476",
    d: "M85.065,126.467a2.5,2.5,0,0,0-.849-2.055,2.591,2.591,0,0,0-3.653.225,2.622,2.622,0,0,0-.6,1.806,2.706,2.706,0,0,0,.925,1.921,2.568,2.568,0,0,0,2.563.414l-2.4-2.065.862-1,3.734,3.223-.1.123a4.035,4.035,0,0,1-6.08-5.3,4.006,4.006,0,0,1,5.64-.377,3.966,3.966,0,0,1,1.229,4.183Z",
    transform: "translate(-43.816 -56.596)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2477",
    "data-name": "Path 2477",
    d: "M88.277,130.724a3.94,3.94,0,1,1-.873-5.516A3.938,3.938,0,0,1,88.277,130.724Zm-5.231-3.818a2.537,2.537,0,1,0,4.112,2.972,2.537,2.537,0,1,0-4.112-2.972Z",
    transform: "translate(-39.58 -53.257)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2478",
    "data-name": "Path 2478",
    d: "M88.135,126.59l-2.463,4.023a2.145,2.145,0,0,0-.414.946,1.132,1.132,0,0,0,.519,1.074,1.155,1.155,0,0,0,1.09.042,2.069,2.069,0,0,0,.768-.86l2.463-4.023,1.2.731-2.463,4.023A3.013,3.013,0,0,1,87.288,134,2.515,2.515,0,0,1,83.9,132a2.9,2.9,0,0,1,.579-2.118l2.463-4.023Z",
    transform: "translate(-35.185 -50.995)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2479",
    "data-name": "Path 2479",
    d: "M87.471,127.015l1.305.681-.854,6.038,4.466-4.154,1.305.681-6.09,5.349-1.025-.535Z",
    transform: "translate(-30.783 -49.116)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2480",
    "data-name": "Path 2480",
    d: "M91.41,128.339l3.713,1.648-.553,1.245-2.432-1.08-.7,1.591,2.327,1.033-.553,1.245-2.327-1.035-.7,1.588,2.429,1.08-.55,1.245-3.713-1.648Z",
    transform: "translate(-27.925 -46.971)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2481",
    "data-name": "Path 2481",
    d: "M92.98,129.134l2.049.773A2.905,2.905,0,0,1,96.68,131.1a2.469,2.469,0,0,1,.162,2.052,2.669,2.669,0,0,1-1.166,1.321,2.468,2.468,0,0,1-1.509.207l.928,3.336-1.62-.611-.833-3.412L91.62,136.7l-1.313-.5Zm.757,4.135a1.638,1.638,0,0,0,1.156.1,1.1,1.1,0,0,0,.613-.642,1.041,1.041,0,0,0-.081-.938,1.52,1.52,0,0,0-.886-.611l-.729-.273L93.019,133Z",
    transform: "translate(-24.738 -45.682)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2482",
    "data-name": "Path 2482",
    d: "M94.744,129.909l1.509.456,1.42,6.2,1.6-5.291,1.342.406-2.183,7.238-1.489-.451-1.447-6.185-1.591,5.27-1.342-.406Z",
    transform: "translate(-21.085 -44.426)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2483",
    "data-name": "Path 2483",
    d: "M97.172,130.7l3.957.917-.307,1.326-2.592-.6-.393,1.7,2.482.574-.307,1.326-2.482-.574-.393,1.7,2.594.6-.309,1.329-3.957-.917Z",
    transform: "translate(-16.378 -43.147)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2484",
    "data-name": "Path 2484",
    d: "M98.756,131.153l1.889.294,1.116,6.025,2.917-5.4,1.882.293-1.158,7.471-1.386-.215.87-5.6-2.8,5.3-1.171-.183-1.064-5.9-.867,5.6-1.386-.215Z",
    transform: "translate(-12.927 -42.41)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2485",
    "data-name": "Path 2485",
    d: "M101.837,131.639l4.049.328-.11,1.357-2.652-.215-.139,1.732,2.539.207-.11,1.357-2.539-.207-.142,1.735,2.652.215-.11,1.355-4.049-.328Z",
    transform: "translate(-7.043 -41.622)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2486",
    "data-name": "Path 2486",
    d: "M103.508,131.8l1.575.026,3.061,5.577.089-5.524,1.4.021-.123,7.561-1.557-.024-3.079-5.556-.092,5.5-1.4-.024Z",
    transform: "translate(-3.544 -41.366)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2487",
    "data-name": "Path 2487",
    d: "M107.476,133.234l-1.389.058-.058-1.36,4.2-.178.058,1.36-1.41.06.262,6.2-1.4.06Z",
    transform: "translate(0.741 -41.438)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2488",
    "data-name": "Path 2488",
    d: "M110.042,131.739l1.09-.1,3.881,7.228-1.538.144-1-1.868-2.668.254-.65,2.023-1.538.147Zm1.756,4.1-1.022-2.2-.587,2.356Z",
    transform: "translate(3.317 -41.626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2489",
    "data-name": "Path 2489",
    d: "M110.4,131.6l1.384-.218.959,6.124,2.283-.356.21,1.344-3.669.574Z",
    transform: "translate(7.828 -42.034)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2490",
    "data-name": "Path 2490",
    d: "M112.051,131.712l3.978-.826.278,1.334-2.6.54.351,1.7,2.495-.516.278,1.331-2.495.516.354,1.7,2.6-.54.275,1.334-3.978.823Z",
    transform: "translate(10.501 -42.843)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2491",
    "data-name": "Path 2491",
    d: "M117.157,138.272,115,131.024l1.709-.506a3.377,3.377,0,0,1,2.073-.2,2.311,2.311,0,0,1,1.5,1.541,2.44,2.44,0,0,1-.312,2.11,3.509,3.509,0,0,1-2.026,1.082l-.265.079.815,2.746Zm.385-4.523a3.882,3.882,0,0,0,1.017-.388.971.971,0,0,0,.393-1.088.925.925,0,0,0-.954-.655,4.452,4.452,0,0,0-1.017.238l-.246.073.563,1.892Z",
    transform: "translate(15.285 -43.924)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2492",
    "data-name": "Path 2492",
    d: "M124.952,131.858a3.938,3.938,0,1,1-5.084-2.309A3.936,3.936,0,0,1,124.952,131.858Zm-6.067,2.264a2.538,2.538,0,1,0,4.746-1.8,2.537,2.537,0,1,0-4.746,1.8Z",
    transform: "translate(19.045 -45.424)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2493",
    "data-name": "Path 2493",
    d: "M121.316,129.5l2,4.272a2.156,2.156,0,0,0,.563.865,1.125,1.125,0,0,0,1.182.157,1.142,1.142,0,0,0,.634-.886,2.039,2.039,0,0,0-.3-1.114l-2-4.272,1.271-.595,2,4.272a3.015,3.015,0,0,1,.37,2.086,2.515,2.515,0,0,1-3.54,1.727,2.9,2.9,0,0,1-1.452-1.646l-2-4.272Z",
    transform: "translate(23.461 -47.643)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2494",
    "data-name": "Path 2494",
    d: "M122.254,128.665l1.918-1.051a2.9,2.9,0,0,1,1.979-.477,2.47,2.47,0,0,1,1.667,1.211,2.663,2.663,0,0,1,.244,1.743,2.472,2.472,0,0,1-.825,1.281l3.137,1.468-1.517.831-3.132-1.585,1.392,2.539-1.229.674Zm3.632,2.117a1.656,1.656,0,0,0,.826-.815,1.11,1.11,0,0,0-.089-.883,1.057,1.057,0,0,0-.765-.55,1.508,1.508,0,0,0-1.038.278l-.684.375,1.077,1.965Z",
    transform: "translate(27.036 -48.982)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2495",
    "data-name": "Path 2495",
    d: "M125.084,126.539l1.171-.771,3.4,5.181,1.934-1.271.747,1.137-3.1,2.042Z",
    transform: "translate(31.623 -51.136)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2496",
    "data-name": "Path 2496",
    d: "M126.472,126.622l3.281-2.4.8,1.1-2.149,1.57,1.027,1.4,2.057-1.5.8,1.1-2.057,1.5,1.025,1.4,2.149-1.567.8,1.1-3.281,2.4Z",
    transform: "translate(33.872 -53.635)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2497",
    "data-name": "Path 2497",
    d: "M128.886,124.848l1.19-1.048a4.78,4.78,0,0,1,2.964-1.433,3.953,3.953,0,0,1,2.917,1.35,3.881,3.881,0,0,1,.92,3.019,4.5,4.5,0,0,1-1.785,2.725l-1.216,1.067Zm5.275,3.616a3.4,3.4,0,0,0,1.292-1.816,2.347,2.347,0,0,0-.55-2.007,2.414,2.414,0,0,0-2.078-.844,3.715,3.715,0,0,0-1.913,1.08l-.076.068,3.195,3.635Z",
    transform: "translate(37.785 -56.651)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2498",
    "data-name": "Path 2498",
    d: "M130.622,122.552l.671-2.589,1.137.372-.781,2.524Zm.684,1.5,2.88-2.867.959.964-1.884,1.876,1.226,1.234,1.806-1.8.959.964-1.806,1.8,1.229,1.232,1.884-1.876.962.964-2.88,2.867Z",
    transform: "translate(40.598 -60.545)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2499",
    "data-name": "Path 2499",
    d: "M132.126,123.55l.977-1.1,5.653,2.3-2.951-5.341.98-1.1,3.713,7.209-.768.865Z",
    transform: "translate(43.035 -63.243)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2500",
    "data-name": "Path 2500",
    d: "M134.04,120.086l2.5-3.2,1.074.839-1.641,2.1,1.373,1.072,1.567-2.007,1.072.839-1.567,2.007,1.371,1.069,1.638-2.1,1.072.839-2.5,3.2Z",
    transform: "translate(46.137 -65.535)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2501",
    "data-name": "Path 2501",
    d: "M135.248,117.246l.807-1.148,5.068,3.577,1.334-1.89,1.111.784-2.141,3.035Z",
    transform: "translate(48.095 -66.809)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2502",
    "data-name": "Path 2502",
    d: "M142.671,113.867a3.941,3.941,0,1,1-5.435,1.295A3.941,3.941,0,0,1,142.671,113.867Zm-3.409,5.509a2.539,2.539,0,1,0,2.649-4.329,2.538,2.538,0,1,0-2.649,4.329Z",
    transform: "translate(50.376 -71.379)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2503",
    "data-name": "Path 2503",
    d: "M144.584,118.043l-6.717-3.472.818-1.58a3.381,3.381,0,0,1,1.295-1.635,2.306,2.306,0,0,1,2.152-.016,2.433,2.433,0,0,1,1.3,1.688,3.506,3.506,0,0,1-.624,2.212l-.126.244,2.545,1.316Zm-2.993-3.412a3.823,3.823,0,0,0,.425-1,.969.969,0,0,0-.511-1.038.924.924,0,0,0-1.135.233,4.584,4.584,0,0,0-.532.9l-.118.228,1.753.907Z",
    transform: "translate(52.34 -74.939)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2504",
    "data-name": "Path 2504",
    d: "M145.742,115.862l-6.908-3.079.726-1.625a3.384,3.384,0,0,1,1.2-1.706,2.3,2.3,0,0,1,2.146-.142,2.428,2.428,0,0,1,1.4,1.609,3.5,3.5,0,0,1-.5,2.243l-.113.254,2.618,1.166Zm-3.187-3.234a3.777,3.777,0,0,0,.37-1.025.967.967,0,0,0-.571-1,.918.918,0,0,0-1.119.3,4.523,4.523,0,0,0-.482.928l-.1.233,1.8.8Z",
    transform: "translate(53.907 -78.135)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2505",
    "data-name": "Path 2505",
    d: "M139.69,110.9l1.444-3.8,1.274.482-.949,2.487,1.627.621.907-2.382,1.271.482-.907,2.382,1.627.618.946-2.487,1.271.485-1.444,3.8Z",
    transform: "translate(55.294 -81.383)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2506",
    "data-name": "Path 2506",
    d: "M140.4,111.4l.548-1.834,6.119-.288-4.953-3.624.545-1.824,7.246,2.162-.4,1.342-5.433-1.62,4.874,3.493-.338,1.137-5.993.252,5.433,1.622-.4,1.344Z",
    transform: "translate(56.445 -86.696)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2507",
    "data-name": "Path 2507",
    d: "M141.347,105.843l.873-3.968,1.329.294-.571,2.6,1.7.375.548-2.49,1.329.294L146,105.431l1.7.375.571-2.6,1.331.294-.873,3.965Z",
    transform: "translate(57.979 -89.859)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2508",
    "data-name": "Path 2508",
    d: "M141.769,105.2l.238-1.557,5.936-2.285-5.464-.831.212-1.386,7.474,1.137-.233,1.538-5.92,2.309,5.443.825-.21,1.386Z",
    transform: "translate(58.663 -94.282)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2509",
    "data-name": "Path 2509",
    d: "M143.624,100.217,143.5,101.6l-1.357-.126.385-4.188,1.355.126-.128,1.4,6.174.566-.128,1.4Z",
    transform: "translate(59.266 -97.29)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_909",
    "data-name": "Group 909",
    transform: "translate(109.192 99.7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_908",
    "data-name": "Group 908",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_907",
    "data-name": "Group 907",
    transform: "translate(-6.13 14.544)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_205",
    "data-name": "Rectangle 205",
    width: 143.53,
    height: 3.411,
    transform: "translate(0 35.949)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_206",
    "data-name": "Rectangle 206",
    width: 143.53,
    height: 3.411,
    transform: "translate(0 45.817)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_207",
    "data-name": "Rectangle 207",
    width: 143.53,
    height: 3.411,
    transform: "translate(0 55.596)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_208",
    "data-name": "Rectangle 208",
    width: 143.53,
    height: 3.411,
    transform: "translate(0 75.374)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_209",
    "data-name": "Rectangle 209",
    width: 143.53,
    height: 3.411,
    transform: "translate(0 85.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_210",
    "data-name": "Rectangle 210",
    width: 143.53,
    height: 3.411,
    transform: "translate(0 95.087)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_211",
    "data-name": "Rectangle 211",
    width: 19.866,
    height: 11.482,
    transform: "translate(9.737)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_212",
    "data-name": "Rectangle 212",
    width: 19.866,
    height: 11.482,
    transform: "translate(110.506)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_213",
    "data-name": "Rectangle 213",
    width: 25.881,
    height: 6.926,
    transform: "translate(3.723 15.674)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_214",
    "data-name": "Rectangle 214",
    width: 25.881,
    height: 6.926,
    transform: "translate(110.871 15.674)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_910",
    "data-name": "Group 910",
    transform: "translate(108.848 99.356)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2510",
    "data-name": "Path 2510",
    d: "M144.482,198.525a64.136,64.136,0,1,1,64.135-64.135A64.21,64.21,0,0,1,144.482,198.525Zm0-127.584A63.448,63.448,0,1,0,207.93,134.39,63.52,63.52,0,0,0,144.482,70.941Z",
    transform: "translate(-80.344 -70.252)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2511",
    "data-name": "Path 2511",
    d: "M119.784,108.006c-.05-.377.055-.912-.322-.964.244-1.221-1.3-.487-.959.322-.532,0-.181.888-.645.962-1.5,1.282-5.357,1.91-3.85,5.134v.962c-.249.071-.372.27-.32.642h-.322a4.264,4.264,0,0,0-.5,4.308,1.8,1.8,0,0,0,.466.527c1.279.658,2.369.113,3.462-.252-.364-.726-.183-.907.443-1.53.008-.246-.031-.553-.016-.807a4.216,4.216,0,0,0,.639-2.246V114.1h.322a1.573,1.573,0,0,0,.642-1.6c-.1-1.276.742-1.612.639-2.888h.322C120.308,109.754,120.308,107.86,119.784,108.006Z",
    transform: "translate(80.593 87.676)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_913",
    "data-name": "Group 913",
    transform: "translate(135.227 141.137)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2512",
    "data-name": "Path 2512",
    d: "M148.5,126.624a.876.876,0,0,0,.639-.962,1.617,1.617,0,0,1,.964-.964h.32c1.019-1.119,2.762-1.515,3.208-3.208-.084-.941.726-.985.645-1.926h.32c1.069-.747,3.09-4.835,1.863-5.868a.45.45,0,0,0-.22-.183.747.747,0,0,0-.147-.039l-.016,0a1.23,1.23,0,0,0-.2,0c-.372-.052-.569.071-.642.32a9.678,9.678,0,0,0-4.169.962h-.322a1.408,1.408,0,0,0-1.281-.639c-.446-1.478-.757-3.092-2.246-3.53a2.9,2.9,0,0,0-1.284-1.284c-1.08.118-.535-1.389-.962-1.924-2.993-3.64-4.19-9.073-7.06-12.833.742,0,1.717,2.482,1.926.962v-.322c.854-.668-.8-1.533-.642-2.566a25.337,25.337,0,0,1-10.438-1.25h0c-.073-.037-.149-.071-.228-.1l-.039-.016c-.068-.029-.136-.052-.207-.079l-.063-.021c-.068-.021-.139-.039-.212-.06l-.066-.018c-.1-.018-.194-.037-.3-.052-.322-.1-.642-.212-.962-.325-.9,1.19-.01,2.285-1.6,2.888-2.487-1.468-5.4-2.511-7.7-4.169a4.218,4.218,0,0,0-.32-3.21h-1.6c-3.373,1.067-7.935-.018-10.268,2.568-.97-.314-1.91-.658-2.888-.964a3.489,3.489,0,0,1-.469.692c-.076.063-.149.131-.22.2-.055.05-.107.1-.16.149q-.149.145-.291.3c-1.368,1.119-3.137,1.832-3.045,4.408h0c-.165.252-.333.5-.511.742h0c-3.47,2.626-7.883,6.814-5.889,11.8.008.755-.553.943-.322,1.926-.406.556-1.082.839-.962,1.924-.092.519.3.553.32.962.267.909-.451.831-.32,1.606a13.667,13.667,0,0,1,2.568,2.243c-.152,1.009.862.849.962,1.606.595,2.078,2.2,3.15,3.85,4.172h.962v.32c-.052.527,1.979.527,1.926,0v-.32h.962c.508-.029,1.224.152,1.284-.322h.32c.273.3,1.656,1.077,1.926.322v-.322c.98.233.943-.553,1.926-.322a6.276,6.276,0,0,0,2.243-.962h1.287c.27.692,1.4.519,1.924.962v.964c1.318.5,3.373.265,3.85,1.6V124.7c-.312.008-.249.393-.32.642-.645.359-.369,2.482,0,2.888,2.146,1.811,3.223,4.688,3.85,8.022-.233.98.553.943.322,1.924a4.857,4.857,0,0,0-1.287,2.888,3.248,3.248,0,0,0-.639,2.568c.176.464-.375,1.659.32,1.6-.052.372.071.569.32.642.314.008.252.39.322.639a.888.888,0,0,0,.642.964,3.77,3.77,0,0,1,.962,2.566c.307,2.8.325,5.878,2.246,7.06-.052.372.071.569.32.639-.2,1.376,1.048,1.31.964,2.568v1.6c1.161,1.418,3.611.6,5.553.362h0a3.4,3.4,0,0,0,.545-.047,4.3,4.3,0,0,1,.639.008c.613-.136,1.381-.118,1.281-.964.577.042.679-.391,1.287-.32a4.542,4.542,0,0,0,1.6-1.6v-.322c.642-.532,1.491-.86,1.6-1.924.608-.037.225-1.061.964-.962a1.235,1.235,0,0,0,.584-1.1c.018-.438-.06-.912-.018-1.347.993-2.222,4.631-1.677,4.811-4.224h-.181c.181-.362.545-.726-.278-1.378a2.271,2.271,0,0,1-.3-.5,3.445,3.445,0,0,1-.259-1.132c-.618-2.623,2.655-2.442,3.653-4.515a4.393,4.393,0,0,0,.5-1.261,7.862,7.862,0,0,0,.144-2.83,2.678,2.678,0,0,0-.01-.548,1.319,1.319,0,0,0-.629-1.056h-.32c.131-.776-.587-.7-.322-1.6-.173-.466.375-1.661-.32-1.606v-.962a10,10,0,0,1,2.566-4.172v-.32C147.574,126.978,148.6,127.363,148.5,126.624Z",
    transform: "translate(-90.41 -86.195)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_912",
    "data-name": "Group 912",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_911",
    "data-name": "Group 911",
    transform: "translate(-30.775 4.128)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_215",
    "data-name": "Rectangle 215",
    width: 143.53,
    height: 3.411,
    transform: "translate(0 9.856)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_216",
    "data-name": "Rectangle 216",
    width: 143.53,
    height: 3.411,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_217",
    "data-name": "Rectangle 217",
    width: 143.53,
    height: 3.411,
    transform: "translate(0 19.713)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_218",
    "data-name": "Rectangle 218",
    width: 143.53,
    height: 3.411,
    transform: "translate(0 29.569)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_219",
    "data-name": "Rectangle 219",
    width: 143.53,
    height: 3.411,
    transform: "translate(0 39.425)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_220",
    "data-name": "Rectangle 220",
    width: 143.53,
    height: 3.411,
    transform: "translate(0 49.282)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_221",
    "data-name": "Rectangle 221",
    width: 143.53,
    height: 3.411,
    transform: "translate(0 59.138)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_222",
    "data-name": "Rectangle 222",
    width: 143.53,
    height: 3.411,
    transform: "translate(0 68.994)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_914",
    "data-name": "Group 914",
    transform: "translate(166.793 144.562)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 19.278,
    cy: 19.278,
    r: 19.278,
    transform: "translate(0.343 0.346)",
    fill: "#262c38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2514",
    "data-name": "Path 2514",
    d: "M122.076,126.749A19.623,19.623,0,1,1,141.7,107.125,19.643,19.643,0,0,1,122.076,126.749Zm0-38.558a18.934,18.934,0,1,0,18.934,18.934A18.955,18.955,0,0,0,122.076,88.191Z",
    transform: "translate(-102.455 -87.502)",
    fill: "#262c38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_915",
    "data-name": "Group 915",
    transform: "translate(143.102 107.726)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_223",
    "data-name": "Rectangle 223",
    width: 4.201,
    height: 26.164,
    transform: "translate(0 4.484)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2515",
    "data-name": "Path 2515",
    d: "M117.3,104.094h-4.2V94.663h-5v9.432h-4.2V78.548a5.117,5.117,0,0,1,5.1-5.1h3.234a5.081,5.081,0,0,1,5.06,5.1Zm-4.2-13.633V81.824c0-2.746-.314-4.576-1.808-4.576h-1.412c-1.4,0-1.774,1.829-1.774,4.576v8.638Z",
    transform: "translate(-76.409 -73.446)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2516",
    "data-name": "Path 2516",
    d: "M110.966,101.326V75.154h9.128a4.655,4.655,0,0,1,4.641,4.641v16.9a4.651,4.651,0,0,1-4.641,4.636h-9.128Zm5.291-4.2h1.111c1.737,0,3.16-1.706,3.16-3.789v-10.2c0-2.086-1.423-3.789-3.16-3.789h-2.2V97.131Z",
    transform: "translate(-64.971 -70.678)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2517",
    "data-name": "Path 2517",
    d: "M110.059,87.459V98.608a4.735,4.735,0,0,1-4.66,5.005h-3.43a5.022,5.022,0,0,1-5.005-5.005V78.748a5.022,5.022,0,0,1,5.005-5.005h7.416V77.9h-6.573s-1.648-.168-1.648,2.351v17a2.2,2.2,0,0,0,2.521,2.165c2.579,0,2.217-2.217,2.217-2.217V91.645h-2.217V87.459Z",
    transform: "translate(-87.663 -72.965)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 110.95,
    cy: 111.085,
    rx: 110.95,
    ry: 111.085,
    transform: "translate(63.1 52.639)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.263
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_916",
    "data-name": "Group 916",
    transform: "translate(62.756 52.294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2518",
    "data-name": "Path 2518",
    d: "M174.186,275.154a111.43,111.43,0,1,1,111.427-111.43A111.556,111.556,0,0,1,174.186,275.154Zm0-222.171A110.741,110.741,0,1,0,284.927,163.724,110.865,110.865,0,0,0,174.186,52.983Z",
    transform: "translate(-62.756 -52.294)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_917",
    "data-name": "Group 917",
    transform: "translate(82.272 71.813)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2519",
    "data-name": "Path 2519",
    d: "M162.117,243.567a91.913,91.913,0,1,1,91.911-91.914A92.019,92.019,0,0,1,162.117,243.567Zm0-183.139a91.225,91.225,0,1,0,91.225,91.225A91.329,91.329,0,0,0,162.117,60.429Z",
    transform: "translate(-70.203 -59.742)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2520",
    "data-name": "Path 2520",
    d: "M69.807,90.024l.9,3.425,3.537.181-2.979,1.915.921,3.42-2.742-2.242-2.968,1.933,1.284-3.3L65,93.131l3.536.2Z",
    transform: "translate(3.645 61.147)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2521",
    "data-name": "Path 2521",
    d: "M146.629,90.024l-.9,3.425-3.537.181,2.979,1.915-.921,3.42,2.742-2.242,2.968,1.933-1.285-3.3,2.755-2.226-3.536.2Z",
    transform: "translate(128.736 61.147)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_918",
    "data-name": "Group 918",
    transform: "translate(170.645 149.059)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2522",
    "data-name": "Path 2522",
    d: "M124.154,121.541l.278-.571.32-.854.605-.755.5-.425.647-.618.364-.71.6-.713.556-.613.411-.427,1.017-.807.781-.71.556-.38.6-.333.419-.33.461-.474.411-.427.228-.283.692-.713.922-1.47.784-1.515.645-1.234.414-.472.233-.807.506-.8.092-.616.186-.618.042-.569.05-.569.136-.283-.273-.094-.233-.139-.092.183-.236.286-.461.142-.689.1-.506.189-.553.047-.32.191h-.278l-.37-.05h-.364l-.461.333-.506.142-.283.047-.37-.047-.228-.047-.325.047-.322.236-.417.191-.317.047-.325-.094-.278-.239-.278-.283-.275-.283-.322-.38-.27-.144-.233-.045-.236.094-.134.047-.186-.191.278-.142.136-.191.375-.139.228-.1.042-.233-.228-.477-.275-.191-.322-.283-.233-.189-.183-.286-.228-.283-.233-.236-.414-.144-.045-.189-.278-.427-.325-.142-.228-.094-.375-.142-.178-.094-.278-.144-.37.047-.141-.377-.228-.38-.186-.427-.047-.472-.045-.333-.136-.425-.508-.951-.322-.33-.278-.38-.411-.236h-.32l-.189-.286-.047-.521-.139-.757v-.713l-.094-.71-.134-.569-.186-.427-.456-.33-.28-.38-.183-.094-.322-.283-.28-.047-.228.139h-.183l-.231.238-.186.33-.275.238-.325.094-.042.236-.186.238-.278-.094-.414-.047-.275-.191-.411.05-.605-.05-.461-.047-.548.047-.6.05-.461.045h-3.5l-1.106-.045-.558-.05-.32.05-.6.141-.186.142v.71l.1.713-.05.377-.231.142-.6.05-.189.047-.045.519V94l.045.71-.089.71v.618l.089.852v.427l-.045.425-.181.1H105.4l-.142.33-.228.474-.278.1-.136.425-.142.38-.089.521-.186.333v.377l-.273.425.042.333.417-.186.181.236-.045.618a.918.918,0,0,0,.231.375,1.955,1.955,0,0,1,.322.333l.047.283.042.474.419.38.231.569.045.616-.089.474.181.286.461.047.233.33.047.236.364.141.325.1.142.238.181.474.325.425.459.047.325.141-.094.286.278.05.092.425.183.142.047.333.367.141.508.142v.663l.414.38.464.474.506.094.506-.141.369.1.275-.335.225.144.142.283.419.38.183.238.273.28.37.191-.092.521-.092.571.275.519-.275.618-.506.236-.228.33-.28.71-.228.427v.713l-.231.66.506.335.275-.286.37-.1.322-.045h.645l.925-.1.92-.047h.878l.37.144.367.142.645.425,1.153.616.736.383s.456.375.6.375.6.521.6.521l.092.333.089.333.461.335.325.142.464.472.362-.047Z",
    transform: "translate(-103.925 -89.218)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2523",
    "data-name": "Path 2523",
    d: "M157.3,201.075s1.046-.024,3.223.1a30.692,30.692,0,0,1,5.865,1.074c2.636.629,4.463,4.091,4.463,4.091l4.589-.459a8.728,8.728,0,0,0-.689-2.639,9.772,9.772,0,0,0-2.065-1.722s3.559-.574,5.509-.689a43.1,43.1,0,0,0,9.411-1.95c2.867-1.033,9.293-4.133,9.293-4.133l2.985-1.376a17.274,17.274,0,0,1-2.238-.4c-.77-.225-1.321-1.439-1.321-1.439a12.078,12.078,0,0,0,6.083,0c2.754-.917,5.393-3.787,6.541-4.935s6.541-5.278,6.541-5.278l-5.163.346.228-2.3a28.3,28.3,0,0,0,3.559-.574c2.065-.459,4.589-1.263,8.376-4.591a31.993,31.993,0,0,0,6.2-7.8l-5.91-.173,1.433-2.123a17.593,17.593,0,0,0,4.7-2.065c2.985-1.722,4.591-5.624,5.624-7.8a81.818,81.818,0,0,0,2.754-8.719,15.65,15.65,0,0,1-2.526,2.178,2.384,2.384,0,0,1-2.293.461l.687-3.559s.92-.343,2.18-.689,3.328-2.639,4.361-4.245,1.606-7.686,1.491-8.834,1.033-5.393,1.033-5.393a11.407,11.407,0,0,0-2.293,1.95,9,9,0,0,1-2.754,1.95v-2.408a14.575,14.575,0,0,0,2.065-1.606,19.2,19.2,0,0,0,2.065-3.213l.115-16.41a19.283,19.283,0,0,1-1.837,1.952,49.349,49.349,0,0,0-3.326,4.015l-.346-2.524a20.239,20.239,0,0,0,2.639-5.393c.574-2.411-.574-5.967-1.033-8.721a31.581,31.581,0,0,1-.343-5.624,15.358,15.358,0,0,1-2.007,2.725,5,5,0,0,1-2.985,1.693s-.38-5.978-1.808-8.462c-2.322-4.046-9.209-7.029-9.209-7.029s-.2,7.3,2.18,10.729a47.842,47.842,0,0,0,4.563,5.165,4.436,4.436,0,0,1-3.126-.4,9.119,9.119,0,0,1-2.5-2.065,44.959,44.959,0,0,0,3.187,10.671,18.581,18.581,0,0,0,6.022,7.057l.087,2.581a13.608,13.608,0,0,1-2.524-1.434,6.251,6.251,0,0,1-1.866-2.18v13a8.03,8.03,0,0,0,1.952,3.184c1.318,1.033,2.524,2.152,2.524,2.152l.173,2.841s-1.206-1.033-2.411-2.238a21.594,21.594,0,0,1-2.065-2.408,116.154,116.154,0,0,1-1.206,12.823c-.7,4.086,2.411,5.422,2.411,5.422l-1.205,4.39A16.714,16.714,0,0,0,225.3,143.4a6.805,6.805,0,0,1-1.378-2.408s-.17,6.368-2.235,9.122-3.014,5.336-3.014,7.23,1.979,4.3,1.979,4.3l-1.376,2.238a8.681,8.681,0,0,1-1.376-2.754c-.246-1.192-.519-2.584-.519-2.584s-3.1,4.819-5.506,7.747-3.1,4.646-3.1,6.025a23.625,23.625,0,0,1-1.376,4.992l-2.065.516.17-6.541s-7.917,7.228-9.122,8.95a18.307,18.307,0,0,0-2.925,6.025,15.5,15.5,0,0,0,.307,2.744s-8.648,4.062-14.44,5.393c-6.371,1.462-15.645,1.245-17.54,1.415s-4.452.131-4.452.131l.024-.008s-2.56.042-4.455-.131-11.169.047-17.537-1.415c-5.792-1.331-14.442-5.393-14.442-5.393a15.706,15.706,0,0,0,.309-2.744,18.317,18.317,0,0,0-2.927-6.025c-1.206-1.722-9.122-8.95-9.122-8.95l.173,6.541-2.068-.516a23.625,23.625,0,0,1-1.376-4.992c0-1.378-.689-3.1-3.1-6.025s-5.509-7.747-5.509-7.747-.273,1.392-.516,2.584a8.722,8.722,0,0,1-1.378,2.754l-1.376-2.238s1.979-2.411,1.979-4.3-.946-4.476-3.011-7.23-2.238-9.122-2.238-9.122a6.836,6.836,0,0,1-1.376,2.411,16.721,16.721,0,0,0-2.068,4.217l-1.2-4.39s3.111-1.337,2.408-5.422a116.141,116.141,0,0,1-1.206-12.823,21.6,21.6,0,0,1-2.065,2.408c-1.206,1.206-2.408,2.238-2.408,2.238l.17-2.841s1.206-1.119,2.526-2.152a8.045,8.045,0,0,0,1.95-3.184v-13a6.261,6.261,0,0,1-1.863,2.18,13.792,13.792,0,0,1-2.526,1.436l.086-2.584a18.6,18.6,0,0,0,6.025-7.057A44.89,44.89,0,0,0,92.4,91.755,9.082,9.082,0,0,1,89.9,93.82a4.443,4.443,0,0,1-3.129.4,47.542,47.542,0,0,0,4.563-5.165c2.377-3.428,2.18-10.729,2.18-10.729s-6.884,2.985-9.209,7.029C82.88,87.842,82.5,93.82,82.5,93.82a4.988,4.988,0,0,1-2.982-1.693A15.238,15.238,0,0,1,77.51,89.4a31.7,31.7,0,0,1-.346,5.621c-.459,2.754-1.606,6.311-1.033,8.722a20.239,20.239,0,0,0,2.639,5.393l-.343,2.524a48.94,48.94,0,0,0-3.328-4.015,19.613,19.613,0,0,1-1.837-1.952l.115,16.41a19.379,19.379,0,0,0,2.065,3.213,14.473,14.473,0,0,0,2.068,1.606v2.411a9.03,9.03,0,0,1-2.754-1.952,11.486,11.486,0,0,0-2.3-1.95s1.148,4.245,1.033,5.393.459,7.228,1.491,8.834,3.1,3.9,4.361,4.248,2.18.687,2.18.687l.689,3.559a2.392,2.392,0,0,1-2.3-.459,15.791,15.791,0,0,1-2.524-2.18,81.818,81.818,0,0,0,2.754,8.719c1.033,2.18,2.639,6.083,5.621,7.8a17.621,17.621,0,0,0,4.707,2.065l1.434,2.123L86,166.4a31.946,31.946,0,0,0,6.2,7.8c3.787,3.328,6.313,4.133,8.378,4.591a28.231,28.231,0,0,0,3.556.574l.231,2.3-5.165-.346s5.393,4.133,6.541,5.278,3.787,4.017,6.541,4.935a12.078,12.078,0,0,0,6.083,0s-.55,1.213-1.321,1.439a17.184,17.184,0,0,1-2.235.4l2.982,1.376s6.426,3.1,9.3,4.133a43.076,43.076,0,0,0,9.408,1.95c1.952.115,5.509.689,5.509.689a9.772,9.772,0,0,0-2.065,1.722,8.809,8.809,0,0,0-.689,2.639l4.591.459s1.824-3.462,4.46-4.091a30.681,30.681,0,0,1,5.868-1.074c2.175-.126,3.223-.1,3.223-.1",
    transform: "translate(15.727 42.194)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcpac);
export default __webpack_public_path__ + "static/media/icpac.3956f4c8292e32d2d8065224ec70af38.svg";
export { ForwardRef as ReactComponent };